// import consts from "../consts";

export default (appName) => {
	return location => {
		return router(location) === appName;
	};
};

function router({hash}) {
	if (hash === "#/empty") {
		return null;
	}
	if (hash.startsWith("#/login/toolbar")) {
		return "AUTH-TOOLBAR";
	}
	if (hash.startsWith("#/login")) {
		return "CALLCENTER";
	}
	if (hash.startsWith("#/token")) {
		return "CALLCENTER";
	}
	if (hash.startsWith("#/callcenter/")) {
		return "CALLCENTER";
	}
	if (hash.startsWith("#/crm/")) {
		return "CRM";
	}
	if (hash.startsWith("#/dashboard/")) {
		return "DIALER";
	}
	return "PBX";
}
